import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import RollOnDispatchIcon from '../../assets/icons/RollOnDispatchIcon';
import '../../assets/style/style.css';
import { Routes } from '../../utils/routes';
import './style.css';
import { API_CONSTANTS } from '../../services/apiConstants';
import { chunkError } from '../../utils/constants/common';
import { dispatchManagerFeatures } from '../../featureFlags/dispatchManagerFeatures';

const { isBlankScreenFixEnabled } = dispatchManagerFeatures;

interface FallbackProps {
    error?: Error;
}

const Fallback: FC<FallbackProps> = ({ error }) => {
    const { t } = useTranslation();
    const queryParams = new URLSearchParams(window.location.search);
    const fallbackMessage = queryParams.get('fallbackMessage');
    const displayMessage =
        fallbackMessage || t('Common:defaultFallbackMessage');

    const [hasChunkError, setHasChunkError] = useState(false);

    useEffect(() => {
        const isChunkError = chunkError?.some(errorMsg =>
            error?.message?.includes(errorMsg),
        );

        if (isChunkError) {
            console.warn('Detected chunk error');
            setHasChunkError(true);
        }
    }, [error]);

    const handleReload = (): void => {
        window.location.reload();
        window.location.href = API_CONSTANTS.dashboard;
    };

    return (
        <div
            className="d-flex flex-column align-items-center justify-content-center"
            id="fallback-container"
        >
            <RollOnDispatchIcon width="500" height="115" />
            <h3>{displayMessage}</h3>
            {hasChunkError ? (
                <div>
                    <p>{t('Common:errorMessage')}</p>
                    <button onClick={handleReload} className="btn btn-primary">
                        {t('Common:retry')}
                    </button>
                </div>
            ) : isBlankScreenFixEnabled ? (
                // Not a router <Link>: this page is also the app-wide error
                // boundary's fallback, which renders outside the router.
                <a href={Routes.login} className="redirect-link">
                    {t('Common:takeMeHome')}
                </a>
            ) : (
                <Link to={Routes.login} className="redirect-link">
                    {t('Common:takeMeHome')}
                </Link>
            )}
        </div>
    );
};

export default Fallback;
